html

<template>
  <md-card v-if="value">
    <md-card-content>
      <div style="display: flex; justify-content: flex-end">
        <md-switch v-model="value.enabled">Active</md-switch>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-size-50">
          <md-field>
            <label>Name</label>
            <md-input v-model="value.name" required />
          </md-field>

          <date-window v-model="value.travel_windows">
            <template v-slot:label>TW</template>
          </date-window>
          <week-days-select v-model="value.travel_days_of_week">
            <template v-slot:label>Days of the week TW</template>
          </week-days-select>
        </div>
        <div class="md-layout-item md-medium-size-100 md-size-50">
          <md-field>
            <label>Anticipation mode</label>
            <md-select v-model="value.anticipation_mode">
              <md-option value="BOOKING_WINDOW">Booking Window</md-option>
              <md-option value="ANTICIPATION_DAYS">Days before arrival</md-option>
            </md-select>
          </md-field>

          <date-window v-if="value.anticipation_mode == 'BOOKING_WINDOW'" v-model="value.booking_windows">
            <template v-slot:label>BW</template>
          </date-window>

          <div class="date-window" v-if="value.anticipation_mode == 'ANTICIPATION_DAYS'">
            <label class="date-window-label">
              DBA
            </label>
            <div class="anticipation-widget">
              <ValidationProvider name="from" rules="required|between:-6000,0" v-slot="{ failed, errors }" slim>
                <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }]">
                  <md-input type="number" v-model="value.anticipation_days_from" placeholder="From"></md-input>
                  <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                </md-field>
              </ValidationProvider>
              <span class="splitter"><md-icon>arrow_forward</md-icon></span>
              <ValidationProvider name="to" rules="required|between:-6000,0" v-slot="{ failed, errors }" slim>
                <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }]">
                  <md-input type="number" v-model="value.anticipation_days_to" placeholder="To"></md-input>
                  <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                </md-field>
              </ValidationProvider>
            </div>
          </div>
          <week-days-select v-model="value.booking_days_of_week">
            <template v-slot:label>Days of the week BW/DBA</template>
          </week-days-select>
          <div class="date-window">
            <label class="date-window-label">
              Timming
            </label>
            <div class="anticipation-widget">
              <md-field style="width: calc(50% - 30px);">
                <md-select v-model="value.time_of_day_from" placeholder="From">
                  <md-option v-for="h in 24" :key="h" :value="`${('0' + (h - 1)).slice(-2)}:00`">{{
                    `${('0' + (h - 1)).slice(-2)}:00`
                  }}</md-option>
                </md-select>
              </md-field>
              <span class="splitter"><md-icon>arrow_forward</md-icon></span>
              <md-field style="width: calc(50% - 30px);">
                <md-select v-model="value.time_of_day_to" placeholder="To">
                  <md-option v-for="h in 24" :key="h" :value="`${('0' + (h - 1)).slice(-2)}:00`">{{
                    `${('0' + (h - 1)).slice(-2)}:00`
                  }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </div>
      </div>

      <template v-for="(rule, index) in rules">
        <pricing-rule
          v-model="rules[index]"
          :key="index"
          :withMoveUp="index > 0"
          :withMoveDown="index < rules.length - 1"
          @moveUp="changeOrder(index, -1)"
          @moveDown="changeOrder(index, 1)"
        ></pricing-rule>
      </template>

      <pricing-rule v-if="new_rule" v-model="new_rule" @rule-created="newRuleCreated"></pricing-rule>

      <md-button v-if="!new_rule" @click="addRule">Add strategy</md-button>
    </md-card-content>
    <md-card-actions>
      <md-button class="md-success" v-on:click="$emit('save', value)">Save</md-button>
      <md-button class="md-danger" v-on:click="deleteItem" style="margin-left: 20px; margin-right: 20px;">Delete</md-button>
      <md-button class="md-default" v-on:click="$emit('close')">Cancel</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import Vue from 'vue'
import DateWindow from '@/components/Pricing/Inputs/DateWindow.vue'
import WeekDaysSelect from './Inputs/WeekDaysSelect.vue'
import PricingRule from './PricingRule.vue'
import { extend } from 'vee-validate'
import { between } from 'vee-validate/dist/rules'

extend('between', { ...between, message: 'Valid value between {min} and {max}' })

export default {
  name: 'PricingStrategyComponent',
  components: {
    PricingRule,
    //draggable,
    DateWindow,
    WeekDaysSelect,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      new_rule: null,
    }
  },
  computed: {
    rules: {
      // since we component works with an array of strategies, we will compute all the
      // strategies subarrays from DTO to a single main array
      get() {
        var rules = []
        Object.keys(this.value)
          .filter((key) => key.endsWith('_strategies') && this.value[key])
          .forEach((key, index) => {
            rules.push(
              ...this.value[key].map((s) => {
                var r = new RegExp(/(\w+)_(strategies)/g)
                s.type = key.replace(r, function(match, p1) {
                  return p1.charAt(0).toUpperCase() + p1.slice(1) + 'PricingStrategy'
                })
                return s
              })
            )
          })

        return rules.filter((r) => !r.deleted).sort((a, b) => a.order - b.order)
      },
    },
  },
  methods: {
    // this methods adds a new "empty" rule on the list of new rules
    addRule() {
      this.new_rule = {
        random_id: Math.floor(Math.random() * 10000),
        is_new: true,
        type: null,
      }
    },
    changeOrder(index, increment) {
      var oldVal = this.rules[index].order
      var newVal = this.rules[index + increment].order

      var itemOld = this.rules[index]
      var itemNew = this.rules[index + increment]

      itemOld.order = newVal
      itemNew.order = oldVal
    },
    // PricingRule component creates the rule according to the type. When if
    // is created, it will be emited to this parent component to update it
    // on is new_rules array
    newRuleCreated(rule) {
      // eslint-disable-next-line
      var array_destination = rule.type.replace(/(\w+)PricingStrategy/g, function(match, p1) {
        return p1.toLowerCase() + '_strategies'
      })
      rule.is_new = false
      rule.order = this.rules.length
      if (this.value[array_destination] == null) this.value[array_destination] = []
      Vue.set(this.value[array_destination], this.value[array_destination].length, rule)

      this.new_rule = null
    },
    deleteItem() {
      if (confirm('Are you sure?')) {
        this.$emit('delete', this.value)
      }
    },
  },
  watch: {
    value: function() {
      this.new_rule = null
    },
  },
}
</script>

<style lang="scss" scoped>
.anticipation-widget {
  display: flex;
  justify-content: space-between;
  //width: calc(100% - 82px);
  .splitter {
    display: flex;
    align-content: center;
    width: 60px;
  }
  .md-input {
    width: 65%;
  }
}
</style>
